import { render, staticRenderFns } from "./NilaiPerolehan.vue?vue&type=template&id=1ac8e91d&"
import script from "./NilaiPerolehan.vue?vue&type=script&lang=js&"
export * from "./NilaiPerolehan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports